var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',{staticClass:"page-view-port",attrs:{"direction":"vertical"}},[_c('Content',{staticClass:"page-content"},[_c('div',{staticClass:"page-content-inner"},[(_vm.currentMenu)?_c('Title'):_vm._e(),_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }